import { getData, http, patchData, postData } from './client'
import { clearTokens, getRefreshToken, setTokens } from './session'
import type { CurrentEmployee, Envelope, LoginResponse } from './types'

/** 구글 ID 토큰으로 로그인. 서버가 사전 등록된 이메일만 통과시킨다. */
export async function loginWithGoogle(idToken: string): Promise<CurrentEmployee> {
  const response = await http.post<Envelope<LoginResponse>>(
    '/auth/google',
    { id_token: idToken },
    // 로그인 자체가 401 이면 리프레시할 것이 없다.
    { _skipAuthRefresh: true } as never,
  )

  const data = response.data.data
  setTokens(data.access_token, data.refresh_token, data.expires_in)

  return data.user
}

export async function fetchMe(): Promise<CurrentEmployee> {
  const data = await getData<{ user: CurrentEmployee }>('/auth/me')

  return data.user
}

/**
 * 표시 언어를 **직원 레코드에** 저장한다 (FR-1.9).
 *
 * `Accept-Language` 헤더만으로는 이 브라우저에서만 유지된다. 관리자 매뉴얼은 고른
 * 언어가 다음 로그인에도 이어진다고 적고 있으므로 서버에도 남겨야 한다 — Twig 의
 * `POST /locale/{locale}` 과 같은 저장이다.
 */
export async function updateLocale(locale: string): Promise<CurrentEmployee> {
  const data = await patchData<{ user: CurrentEmployee }>('/auth/me', { locale })

  return data.user
}

/**
 * 로그아웃. 서버에서 리프레시 토큰을 폐기한다. 네트워크가 실패해도 **로컬은
 * 반드시 지운다** — 안 지우면 로그아웃 버튼이 아무 일도 안 한 것처럼 보인다.
 */
export async function logout(): Promise<void> {
  const refreshToken = getRefreshToken()
  try {
    if (null !== refreshToken) {
      await postData('/auth/logout', { refresh_token: refreshToken }, {
        _skipAuthRefresh: true,
      } as never)
    }
  } finally {
    clearTokens()
  }
}
